import { sortBy } from 'underscore';
import { Distance, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Spread items by center command
 *
 * @class SpreadItemsByCenterCommand
 * @extends AbstractCommand
 */
export default class SpreadItemsByCenterCommand extends AbstractCommand {
    constructor(items, spreadVertical) {
        super();

        if (!Array.isArray(items) || items.length <= 1) {
            throw new Error('Too few items are selected.');
        }

        this.items = items;
        this.alignVertical = !!spreadVertical;
        this.initialPositions = {};

        this.items.forEach(item => (this.initialPositions[item.cid] = item.get('position').clone()));
    }

    /**
     * Execute command
     */
    execute() {
        const axisArray = this.alignVertical ? ['y', 'x'] : ['x', 'y'];
        let areaBounds = null;

        const sortedItems = sortBy(this.items, (item) => {
            const itemBounds = item.getBounds();
            const itemPosition = itemBounds.getCenter();

            if (areaBounds) areaBounds = areaBounds.merge(itemBounds);
            else areaBounds = itemBounds.clone();

            return (itemPosition[axisArray[0]] * 100000) + itemPosition[axisArray[1]];
        });

        const startPosition = sortedItems[0].getBounds().getCenter()[axisArray[0]];
        const endPosition = sortedItems[sortedItems.length - 1].getBounds().getCenter()[axisArray[0]];
        const stepWidth = (endPosition - startPosition) / (sortedItems.length - 1);

        sortedItems.forEach((item, index) => {
            const initialPosition = item.get('position').clone();
            const itemBounds = item.getBounds();
            const distance = new Distance(initialPosition, itemBounds.getCenter()).point;

            initialPosition[axisArray[0]] = (startPosition + (index * stepWidth)) - distance[axisArray[0]];
            item.set('position', initialPosition);
        });
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.items.forEach(item => item.set('position', this.initialPositions[item.cid]));
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Spread items by center ${this.alignVertical ? 'vertical' : 'horizontal'}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SpreadItemsByCenterCommand = SpreadItemsByCenterCommand;
